<template>
    <div>
        <vue-headful
        :title="post.title"
        :description="post.meta_description"
        />
        <article class="post">
            <div class="title">
                <h2 class="title is-size-2" v-html="post.title"></h2>
            </div>
            <span v-html="post.content" class="mb-6 content"></span>
        </article>
    </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Post",
  props: {
    slug: String
  },
  data() {
    return {
      post: {title: "", content: ""}
    };
  },
  methods: {
    async getPost(slug) {
      let key = "VUE_APP_API_URL_" + String(this.$i18n.locale).toUpperCase();
      this.posts = [];
      let response = await axios.get(process.env[key] + "wp-json/blackdigital/v1/posts");
      this.posts = response.data;
      this.post = this.posts.filter((post) => post.slug == slug)[0];
    },
  },
  mounted() {
    this.getPost(this.slug);
  },
};
</script>